import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslationService } from 'src/app/core/services/translation/translation.service';

@Component({
  selector: 'app-account-settings-tab-group',
  templateUrl: './account-settings-tab-group.component.html',
  encapsulation: ViewEncapsulation.None,
})

/**
 * Account Settings Tab Group
 */
export class AccountSettingsTabGroupComponent implements OnInit {
  currentTabIndex = 0;
  labels = {
    account: 'account',
    settings: 'settings',
  };

  /**
   * @constructor
   */
  constructor(private translationService: TranslationService) {}

  /**
   * on init
   */
  ngOnInit(): void {
    this.translationService.translateObject(this.labels);
  }

  /**
   * returns tab index
   * @return {number}
   */
  getSelectedIndex(): number {
    return this.currentTabIndex;
  }
}
